import styled from 'styled-components';
import { PriceTable } from './PriceTable';
import useBreakpoints from '../hooks/useBreakpoints';
import { PriceTableMobile } from './PriceTableMobile';

export default function PriceSection() {
  const media = useBreakpoints({ defaultMedia: 'desktop' });

  return (
    <Container>
      <Wrapper>
        <Top>
          <TitleWrapper>
            <FakeTitle>우리집 청소 51,100원 부터~</FakeTitle>
            <TitleDesktop>{TitleDesktopSvg}</TitleDesktop>
            <TitleTablet>{TitleTabletSvg}</TitleTablet>
          </TitleWrapper>
          <TopContent>
            <Description>
              지역과 평수에 따라 서비스 비용과 시간에 차이가 있습니다. 정확한 비용 및 시간은 앱에서 확인이 가능합니다.
            </Description>
          </TopContent>
        </Top>
        <Bottom>{media !== 'mobile' ? <PriceTable /> : <PriceTableMobile />}</Bottom>
      </Wrapper>
    </Container>
  );
}

const Container = styled.section`
  position: relative;
  width: 100%;
  background: #22afc0;
  overflow: hidden;
  padding: 0 24px;
`;

const Wrapper = styled.div`
  margin: 0 auto;
  max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.desktop};

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.tablet};
  }
`;

const Top = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  padding-top: 100px;
  padding-bottom: 84px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    padding-top: 76px;
    padding-bottom: 60px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    flex-direction: column;
    padding-top: 70px;
    padding-bottom: 70px;
  }
`;

const TitleWrapper = styled.div`
  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    margin-bottom: 16px;
  }
`;

const FakeTitle = styled.h1`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  text-indent: -5000px;
`;

const TitleDesktop = styled.div`
  display: block;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    display: none;
  }
`;

const TitleTablet = styled.div`
  display: none;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    display: block;
  }
`;

const TopContent = styled.div``;

const Description = styled.h2`
  word-break: keep-all;
  font-weight: 400;
  font-size: 21px;
  line-height: 140%;
  width: 502px;
  color: #ffffff;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 17px;
    width: 405px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    width: auto;
  }
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 68px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    padding-bottom: 62px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    flex-direction: column-reverse;
    padding-bottom: 39px;
  }
`;

const PriceDl = styled.dl`
  width: 100%;
`;

const PriceRow = styled.div`
  padding: 24px 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1.5px solid #169fb5;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    padding: 20px 0;
  }
`;

const PriceDt = styled.dt`
  font-weight: 300;
  font-size: 24px;
  line-height: 140%;
  color: #ffffff;
  margin: auto 0;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 21px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 16px;
    font-weight: 400;
  }
`;

const Pricedd = styled.dd`
  font-weight: 500;
  font-size: 26px;
  line-height: 140%;
  color: #ffffff;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 21px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 16px;
  }
`;

const TitleDesktopSvg = (
  <svg width="293" height="105" viewBox="0 0 293 105" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.8186 11.516C26.8186 8.02 23.7366 5.536 19.5506 5.536C15.2266 5.536 12.2826 8.02 12.2826 11.516C12.2826 14.92 15.2266 17.634 19.5506 17.634C23.7366 17.634 26.8186 14.92 26.8186 11.516ZM22.0806 42.474H17.0666V28.674H0.184625V24.35H38.9166V28.674H22.0806V42.474ZM32.0626 11.516C32.0626 18.324 25.9446 22.004 19.5506 22.004C13.0646 22.004 7.03863 18.324 7.03863 11.516C7.03863 5.03 12.7426 0.981998 19.5506 0.981998C26.5426 0.981998 32.0626 5.076 32.0626 11.516ZM68.445 23.43L68.997 27.708C62.833 29.134 51.885 29.41 44.249 29.042V13.402H58.555V7.284H44.157V2.868H63.661V17.726H49.355V24.764C54.231 24.994 63.155 24.534 68.445 23.43ZM72.309 39.07V0.751998H77.369V39.07H72.309ZM114.165 39.852V34.976H99.4454V39.852H114.165ZM114.165 23.66V0.659999H119.271V23.66H114.165ZM94.1094 6.916H85.4154V2.546H107.771V6.916H99.4454C99.4914 9.906 100.457 12.436 102.251 14.414C104.137 16.438 106.667 17.956 109.841 18.968L107.357 23.108C102.895 21.636 98.8474 18.554 96.8234 14.552C95.1674 18.646 91.0734 21.958 86.4734 23.798L84.0814 19.612C87.1634 18.508 89.6014 16.898 91.3954 14.736C93.1894 12.62 94.0634 9.998 94.1094 6.916ZM119.271 44.222H94.3394V25.96H99.4454V30.698H114.165V25.96H119.271V44.222ZM155.85 5.214H142.694V0.843999H155.85V5.214ZM166.936 35.804C166.936 32.86 164.36 31.02 160.542 31.02C156.862 31.02 154.24 32.86 154.24 35.804C154.24 38.748 156.862 40.588 160.542 40.588C164.36 40.588 166.936 38.748 166.936 35.804ZM172.64 26.144H167.534V18.14H160.266V13.862H167.534V0.614H172.64V26.144ZM146.512 12.206H137.91V7.882H160.588V12.206H152.262C152.354 13.172 152.584 14.092 152.906 14.874C154.286 18.14 157.69 20.302 161.784 21.406L159.576 25.546C155.528 24.304 150.882 21.314 149.41 18.048C147.984 21.36 143.66 25.04 139.106 26.374L136.714 22.326C140.67 20.808 144.212 18.692 145.776 15.15C146.19 14.276 146.42 13.31 146.512 12.206ZM172.088 35.804C172.088 41.186 167.304 44.958 160.542 44.958C153.918 44.958 149.088 41.186 149.088 35.804C149.088 30.514 153.918 26.696 160.542 26.696C167.304 26.696 172.088 30.514 172.088 35.804ZM216.475 34.976H177.743V30.56H194.625V21.636H199.639V30.56H216.475V34.976ZM194.165 1.81H200.053V4.34C200.053 11.746 206.447 16.76 213.623 18.738L211.277 23.154C204.515 21.13 199.501 17.22 197.109 12.252C194.947 17.266 189.427 21.084 182.987 23.2L180.595 18.784C187.863 16.944 194.165 11.7 194.165 4.34V1.81ZM9.98263 96.678C6.25663 96.678 2.80663 95.436 0.828625 94.01L2.34663 89.594C3.95663 90.698 6.85463 91.848 9.15463 91.848C13.2946 91.848 15.9626 89.64 15.9626 85.592C15.9626 81.222 12.9726 79.612 8.87863 79.612C7.08463 79.612 3.72663 80.486 2.16263 81.406L3.31263 62.868H20.1026V67.514H7.68263L7.22263 75.748C8.23463 75.38 10.0286 75.15 11.2246 75.15C17.0666 75.15 21.4366 78.508 21.4366 85.638C21.4366 91.848 16.7906 96.678 9.98263 96.678ZM32.6613 96.448V68.756L27.3713 69.906V66.41L35.1913 62.546H37.9053V96.448H32.6613ZM45.9438 98.288V92.676H51.8778V97.322C51.8778 100.91 49.6238 104.176 45.8978 105.004L45.2538 102.612C47.4618 102.106 48.7498 100.22 48.7498 98.288H45.9438ZM61.3682 96.448V68.756L56.0782 69.906V66.41L63.8982 62.546H66.6122V96.448H61.3682ZM86.7785 92.262C90.8725 92.262 93.4025 88.812 93.4025 80.946V78.37C93.4025 70.412 90.8725 66.916 86.8245 66.916C82.6845 66.916 80.1085 70.366 80.1085 78.14V80.762C80.1085 88.582 82.5925 92.262 86.7785 92.262ZM86.7325 96.77C80.1545 96.77 74.6805 92.17 74.6805 80.716V78.646C74.6805 66.64 80.6145 62.362 86.8245 62.362C93.0805 62.362 98.7845 66.732 98.7845 78.462V80.578C98.7845 92.354 93.0345 96.77 86.7325 96.77ZM114.519 92.262C118.613 92.262 121.143 88.812 121.143 80.946V78.37C121.143 70.412 118.613 66.916 114.565 66.916C110.425 66.916 107.849 70.366 107.849 78.14V80.762C107.849 88.582 110.333 92.262 114.519 92.262ZM114.473 96.77C107.895 96.77 102.421 92.17 102.421 80.716V78.646C102.421 66.64 108.355 62.362 114.565 62.362C120.821 62.362 126.525 66.732 126.525 78.462V80.578C126.525 92.354 120.775 96.77 114.473 96.77ZM143.271 65.306C140.097 65.306 137.981 67.146 137.981 69.584C137.981 71.976 140.097 73.77 143.271 73.77C146.583 73.77 148.515 71.976 148.515 69.584C148.515 67.146 146.583 65.306 143.271 65.306ZM166.685 103.164H140.741V91.94H145.847V98.84H166.685V103.164ZM145.387 89.87H140.235V84.166H140.189C136.877 84.258 132.875 84.396 130.023 84.396L129.333 79.796C133.657 79.888 138.165 79.842 142.535 79.75C147.227 79.612 153.805 79.06 156.933 78.692L157.255 82.786C153.805 83.384 148.101 83.844 145.387 83.936V89.87ZM160.797 85.546V60.706H165.949V93.78H160.797V89.732H151.643V85.546H160.797ZM153.529 69.63C153.529 74.552 149.665 78.094 143.271 78.094C137.153 78.094 132.967 74.506 132.967 69.538C132.967 64.57 137.153 60.982 143.271 60.982C149.665 60.982 153.529 64.616 153.529 69.63ZM210.394 76.392V71.378H194.294V76.392H210.394ZM204.92 102.474H199.906V89.042H183.024V84.718H221.756V89.042H204.92V102.474ZM215.454 80.67H189.188V61.488H194.294V67.054H210.394V61.488H215.454V80.67ZM260.76 99.07H255.654V76.254H247.972V71.884H255.654V60.752H260.76V99.07ZM226.72 88.306V62.822H246.27V67.238H231.872V72.804H245.35V77.036H231.872V83.752C236.978 83.982 243.924 83.752 249.076 82.74L249.536 87.064C244.43 88.168 235.092 88.766 226.72 88.306ZM279.893 75.702C281.365 77.128 283.159 78.554 285.091 78.554C286.931 78.554 288.633 76.576 288.863 73.862L292.681 75.38C291.761 80.67 288.219 83.062 285.137 83.062C282.699 83.062 280.813 82.28 279.019 80.578C277.317 78.876 275.983 77.634 273.959 77.726C272.257 77.772 270.877 79.336 270.233 82.188L266.599 80.44C267.887 74.782 271.061 73.264 274.465 73.218C276.535 73.218 278.559 74.414 279.893 75.702Z"
      fill="white"
    />
  </svg>
);

const TitleTabletSvg = (
  <svg width="174" height="66" viewBox="0 0 174 66" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.6494 13.8525V16.5947H13.2627V24.4521H9.94043V16.5947H0.685547V13.8525H22.6494ZM11.6016 1.22266C16.7432 1.22266 20.3555 3.3584 20.3555 6.68066C20.3555 9.9502 16.7432 12.0332 11.6016 12.0332C6.45996 12.0332 2.87402 9.9502 2.90039 6.68066C2.87402 3.3584 6.45996 1.22266 11.6016 1.22266ZM11.6016 3.91211C8.38477 3.91211 6.32812 4.91406 6.35449 6.68066C6.32812 8.39453 8.38477 9.37012 11.6016 9.37012C14.8447 9.37012 16.875 8.39453 16.875 6.68066C16.875 4.91406 14.8447 3.91211 11.6016 3.91211ZM44.165 0.431641V24.4785H40.8164V0.431641H44.165ZM36.7295 2.43555V11.6904H28.8193V16.0938C32.4712 16.0806 35.5825 15.8696 39.1025 15.3027L39.3926 18.0186C35.4375 18.7041 31.8779 18.8623 27.501 18.8623H25.3389V9.02734H33.3018V5.15137H25.3125V2.43555H36.7295ZM61.5674 1.75V4.43945H56.7686C56.9268 6.9707 58.7329 9.50195 62.4902 10.5303L60.8027 13.1406C58.0605 12.3628 56.1357 10.7148 55.0547 8.60547C53.9604 10.8862 51.9961 12.6924 49.1484 13.5625L47.4609 10.9258C51.2842 9.81836 53.1431 7.15527 53.3145 4.43945H48.3838V1.75H61.5674ZM67.4736 0.431641V13.457H64.0986V0.431641H67.4736ZM54.7383 14.459V16.7002H64.125V14.459H67.4736V24.1621H51.416V14.459H54.7383ZM54.7383 21.4727H64.125V19.3105H54.7383V21.4727ZM90.624 2.93652V5.57324H85.7725C85.7988 8.03857 87.6182 10.5435 91.4678 11.5322L89.9121 14.1162C87.1831 13.4307 85.2583 11.9146 84.1641 9.9502C83.1226 12.1914 81.1978 13.9448 78.3633 14.749L76.7812 12.1387C80.6309 11.0444 82.3975 8.30225 82.4238 5.57324H77.5986V2.93652H82.4238V0.326172H85.8252V2.93652H90.624ZM97.1631 0.431641V14.9336H93.8145V9.55469H89.9121V6.86523H93.8145V0.431641H97.1631ZM88.9629 15.3291C94.0781 15.3555 97.2158 16.9639 97.2422 19.8379C97.2158 22.7383 94.0781 24.4258 88.9629 24.4258C83.874 24.4258 80.71 22.7383 80.71 19.8379C80.71 16.9639 83.874 15.3555 88.9629 15.3291ZM88.9629 17.9131C85.7725 17.9131 84.0586 18.5459 84.0586 19.8379C84.0586 21.1562 85.7725 21.8682 88.9629 21.8682C92.2061 21.8682 93.8936 21.1562 93.8936 19.8379C93.8936 18.5459 92.2061 17.9131 88.9629 17.9131ZM122.238 18.8623V21.5518H100.274V18.8623H109.45V13.4307H112.799V18.8623H122.238ZM112.904 3.5166C112.904 6.94434 115.989 10.5566 121.474 11.4004L120.05 14.1953C115.831 13.4307 112.693 11.1763 111.111 8.18359C109.529 11.1631 106.418 13.4438 102.226 14.1953L100.802 11.4004C106.233 10.5566 109.292 6.91797 109.318 3.5166V1.80273H112.904V3.5166ZM8.5166 60.2637C4.53516 60.2637 1.63477 57.917 1.55566 54.6211H5.40527C5.48438 56.124 6.85547 57.126 8.5166 57.126C10.4941 57.126 11.8916 55.7285 11.8916 53.751C11.8916 51.7207 10.4678 50.3232 8.46387 50.2969C7.04004 50.2969 6.03809 50.8242 5.45801 51.9053H1.87207L2.90039 40.9102H14.6602V44.1533H6.16992L5.64258 48.9785H5.80078C6.5127 48.0293 7.93652 47.3701 9.62402 47.3701C13.1309 47.3701 15.7412 49.9805 15.7412 53.6455C15.7412 57.4951 12.8145 60.2637 8.5166 60.2637ZM26.6572 40.9102V60H22.6758V44.6807H22.5703L18.1934 47.4229V43.916L22.9131 40.9102H26.6572ZM34.3301 58.0488L32.0625 65.5635H29.2676L30.5859 58.0488H34.3301ZM43.6641 40.9102V60H39.6826V44.6807H39.5771L35.2002 47.4229V43.916L39.9199 40.9102H43.6641ZM55.5029 60.2637C50.7305 60.2637 47.8301 56.7041 47.8301 50.4551C47.8301 44.2061 50.7305 40.6465 55.5029 40.6465C60.2754 40.6465 63.1758 44.2324 63.1758 50.4551C63.1758 56.7305 60.2754 60.2637 55.5029 60.2637ZM55.5029 56.9941C57.7178 56.9941 59.1416 54.8584 59.1152 50.4551C59.1152 46.1045 57.7178 43.8896 55.5029 43.8896C53.2881 43.8896 51.8906 46.1045 51.8906 50.4551C51.8643 54.8584 53.2881 56.9941 55.5029 56.9941ZM73.3271 60.2637C68.5547 60.2637 65.6543 56.7041 65.6543 50.4551C65.6543 44.2061 68.5547 40.6465 73.3271 40.6465C78.0996 40.6465 81 44.2324 81 50.4551C81 56.7305 78.0996 60.2637 73.3271 60.2637ZM73.3271 56.9941C75.542 56.9941 76.9658 54.8584 76.9395 50.4551C76.9395 46.1045 75.542 43.8896 73.3271 43.8896C71.1123 43.8896 69.7148 46.1045 69.7148 50.4551C69.6885 54.8584 71.1123 56.9941 73.3271 56.9941ZM103.28 38.458V56.5723H99.9053V54.6738H95.3174V52.3799H99.9053V38.458H103.28ZM103.808 59.3145V62.0039H85.9307V54.832H89.2793V51.6416C87.1304 51.7339 85.0869 51.7471 83.2676 51.7471L82.8721 49.084C87.2754 49.0576 93.208 49.0049 98.2705 48.3721L98.4551 50.7715C96.5566 51.0879 94.5923 51.312 92.6543 51.457V56.0186H89.2793V59.3145H103.808ZM90.6768 39.2754C94.1572 39.249 96.6621 41.0156 96.6621 43.5732C96.6621 46.1309 94.1572 47.792 90.6768 47.792C87.1172 47.792 84.6387 46.1309 84.6387 43.5732C84.6387 41.0156 87.0908 39.249 90.6768 39.2754ZM90.6768 41.7275C88.9629 41.7275 87.8027 42.3867 87.8291 43.5732C87.8027 44.7334 88.9629 45.3662 90.6768 45.3662C92.2852 45.3662 93.4453 44.7334 93.4717 43.5732C93.4453 42.3867 92.2852 41.7275 90.6768 41.7275ZM134.446 52.2744V54.9111H125.06V62.4258H121.737V54.9111H112.482V52.2744H134.446ZM118.389 39.3545V42.123H128.461V39.3545H131.836V49.9541H115.066V39.3545H118.389ZM118.389 47.2646H128.461V44.7598H118.389V47.2646ZM156.094 38.4316V62.4785H152.771V49.6113H148.553V46.8955H152.771V38.4316H156.094ZM148.157 40.4355V43.1514H140.3V47.1328H147.287V49.7695H140.3V54.3047C143.622 54.2783 146.285 54.1597 149.265 53.6982L149.607 56.3877C146.101 56.915 142.963 57.0469 138.85 57.0469H136.951V40.4355H148.157ZM160.972 51.5361C161.868 50.5869 163.002 50.0859 164.241 50.0859C166.403 50.0859 168.249 51.5889 170.411 51.5889C171.624 51.5889 172.731 51.0879 173.602 50.1387V53.3555C172.705 54.3047 171.571 54.8057 170.332 54.8057C168.17 54.8057 166.324 53.3027 164.162 53.3027C162.949 53.3027 161.842 53.8037 160.972 54.7529V51.5361Z"
      fill="white"
    />
  </svg>
);
